import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from '@/services/api/internal/tools/client.js';

const URL = `${process.env.P2C_BASE_URI}/requests`;

const RequestsAPI = new BaseAPI({ url: URL });

RequestsAPI.updateLimitDatetime = (id, date) => {
  return Client.put(`${URL}/${id}/change_limit_datetime`, date).catch(
    errorHandler
  );
};

export default RequestsAPI;
